export default "__VITE_ASSET__1VBmo84Z__"